var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8104 59.0486L51.8578 65.3981L56.8104 71.7476",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7157 59.0486L71.6683 65.3981L66.7157 71.7476",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5735 83.1766C82.887 83.1766 84.1467 82.6414 85.0755 81.6888C86.0043 80.7362 86.5261 79.4442 86.5261 78.097V52.699C86.5261 51.3518 86.0043 50.0598 85.0755 49.1072C84.1467 48.1546 82.887 47.6194 81.5735 47.6194H62.0107C61.1824 47.6277 60.3653 47.4228 59.6342 47.0235C58.9031 46.6242 58.2813 46.0431 57.8257 45.3336L55.8199 42.2858C55.369 41.5835 54.755 41.007 54.0333 40.608C53.3115 40.2091 52.5044 40.0001 51.6845 40H41.9526C40.6391 40 39.3794 40.5352 38.4506 41.4878C37.5218 42.4404 37 43.7324 37 45.0796V78.097C37 79.4442 37.5218 80.7362 38.4506 81.6888C39.3794 82.6414 40.6391 83.1766 41.9526 83.1766H81.5735Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs7);
export default __webpack_public_path__ + "static/media/IconFaqs7.4310f89470889a9af6ac375e97d6b144.svg";
export { ForwardRef as ReactComponent };